S.imageSlider =
    {
        elements: {
            $slides: null,
            $slidesMobile: null,
            $prev: null,
            $next: null,
            $slide: null,
            $dots: null,
        },

        init()
        {
            const $slides = this.elements.$slides;
            const $slidesMobile = this.elements.$slidesMobile;
            const $pagination = this.elements.$dots;
            const $activedot = ((parseInt($slides.css('left'), 10)) / (parseInt($slides.css('width'), 10) / $slides.children().length) * (-1));

            $pagination.children().each(function ()
            {
                $(this).removeClass('is-active');
                if (parseInt($(this).attr('data'), 10) === $activedot + 1)
                {
                    $(this).addClass('is-active');
                }
            });

            this.elements.$dots.children().each(function ()
            {
                $(this).on('click', function ()
                {
                    $slides.animate({left: (parseInt($slides.css('width'), 10) / $slides.children().length) * (-1) * ($(this).attr('data') - 1)}, 300);
                    $pagination.children().each(function ()
                    {
                        $(this).removeClass('is-active');
                    });
                    $(this).addClass('is-active');
                });
            });

            this.elements.$prev.on('click', function ()
            {
                const $fullwidth = $slides.css('width');
                const $prevpos = $slides.css('left');
                const $numSlides = $slides.children().length;
                let $pos = parseInt($prevpos, 10) + parseInt($fullwidth, 10) / parseInt($numSlides, 10);

                if (parseInt($prevpos, 10) >= 0)
                {
                    $pos = parseInt($fullwidth, 10) * (-1) + (parseInt($fullwidth, 10) / $numSlides);
                }
                let $activedot = ((parseInt($prevpos, 10)) / (parseInt($fullwidth, 10) / $numSlides) * (-1));

                if ($activedot === 0) { $activedot = $numSlides; }
                $slides.animate({left: $pos}, 300);
                $slidesMobile.animate({left: $pos}, 300);
                $pagination.children().each(function ()
                {
                    $(this).removeClass('is-active');
                    if (parseInt($(this).attr('data'), 10) === $activedot)
                    {
                        $(this).addClass('is-active');
                    }
                });
            });

            this.elements.$next.on('click', function ()
            {
                const $fullwidth = $slides.css('width');
                const $prevpos = $slides.css('left');
                const $numSlides = $slides.children().length;
                let $pos = parseInt($prevpos, 10) - parseInt($fullwidth, 10) / parseInt($numSlides, 10);

                if (parseInt($prevpos, 10) <= parseInt($fullwidth, 10) * (-1) + (parseInt($fullwidth, 10) / $numSlides))
                {
                    $pos = 0;
                }
                let $activedot = ((parseInt($prevpos, 10)) / (parseInt($fullwidth, 10) / $numSlides) * (-1) + 1);

                if ($activedot === $numSlides)
                {
                    $activedot = 0;
                }
                $slides.animate({left: $pos}, 300);
                $slidesMobile.animate({left: $pos}, 300);
                $pagination.children().each(function ()
                {
                    $(this).removeClass('is-active');
                    if (parseInt($(this).attr('data'), 10) - 1 === $activedot)
                    {
                        $(this).addClass('is-active');
                    }
                });
            });
        },
    };
